import classNames from 'classnames';
import * as React from 'react';
import { useDeviceCondition } from '../../../../../../hooks';
import { Shimmer } from '../../../../../common/Shimmer';
import * as styles from './PromotionLayout.css';

export interface IPromotionLayoutProps {
  loading: boolean;
  promotionLabel: React.ReactNode;
  betPosition: React.ReactNode;
}

export const PromotionLayout = ({ loading, promotionLabel, betPosition }: IPromotionLayoutProps) => {
  const rootStyle = useDeviceCondition(styles['desktop'], styles['mobile']);

  return (
    <div className={classNames(rootStyle, styles['wrapper'])}>
      <Shimmer theme="white" running={loading}>
        <div className={styles['promotion']}>
          {promotionLabel}
          {betPosition && <div className={styles['position']}>{betPosition}</div>}
        </div>
      </Shimmer>
    </div>
  );
};
